import React from "react"

export type CtxType = {
  activeData: Record<string, any>
  userData: Record<string, any>
  formType: number
  isDeleting: boolean
  showForm: boolean
  resetForm: boolean
  setShowForm: Function
  setActiveData: Function
  showFormType: Function
  resetData: Function
  showResetForm: Function
  setUserData: Function
  handleDeleteUser: Function
}

export const Context = React.createContext<Partial<CtxType>>({})
